export default {
  isOpen: true,
  __typename: "sidebar"
};
